var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "#E6EEF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8984 37.8027C59.8594 38.2031 60.4199 39.1641 60.5 40.125C60.5 41.166 59.8594 42.127 58.8984 42.5273L23.0234 57.9023C22.7031 58.0625 22.3828 58.1426 22.0625 58.1426C21.3418 58.1426 20.6211 57.8223 20.1406 57.2617C19.4199 56.541 19.2598 55.3398 19.7402 54.3789L27.1875 40.125L19.7402 25.9512C19.2598 24.9902 19.4199 23.7891 20.1406 22.9883C20.6211 22.4277 21.3418 22.1875 22.0625 22.1875C22.3828 22.1875 22.7031 22.2676 23.0234 22.4277L58.8984 37.8027ZM24.7852 27.3926L30.4707 38.2031H50.1699L24.7852 27.3926ZM30.4707 42.0469L24.7852 52.9375L50.1699 42.0469H30.4707Z",
    fill: "#0073C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame3.cbebe851911fff449f8d74685118ba09.svg";
export { ForwardRef as ReactComponent };